/**
 * Represents a single map marker for the Search Results map widget
 *
 * This directly extends from the Google Maps Marker object
 * @param {SearchMap} map     The map to attach to
 * @param {Array} listings    An array of multiple search results
 * @param {decimal} lat       Latitude of the marker
 * @param {decimal} lng       Longitude of the marker
 */
function SearchMapMarkerMulti(map, listings) {
    this.map = map;
    this.listings = listings;
    this.lat = listings[0].lat;
    this.lng = listings[0].lng;
    this.markerType = 'multi';
    this.show = false;
    this.label = listings.length.toString();

    var markerOptions = {
        position: new google.maps.LatLng(this.lat, this.lng),
        map: this.map,
        title: listings.length + " units",
        icon: this.getMarkerImage(false, this.label)
    };

    //Construct the parent
    google.maps.Marker.call(this, markerOptions);

    this.addListeners();
}

if(typeof google.maps.Marker === undefined) {
    console.error("Google Maps Marker library was not found");
}

//Extend the Google Maps marker
SearchMapMarkerMulti.prototype = Object.create(google.maps.Marker.prototype);
SearchMapMarkerMulti.prototype.constructor = google.maps.Marker;

/**
 * Adds event listeners for when the marker is clicked or hovered
 */
SearchMapMarkerMulti.prototype.addListeners = function() {
    // Open infobox when marker is clicked
    google.maps.event.addListener(this, 'click', this.evtMarkerClick.bind(this));
    google.maps.event.addListener(this, 'mouseover', this.evtMarkerHover.bind(this));
    google.maps.event.addListener(this, 'mouseout', this.evtMarkerHoverLeave.bind(this));
};

/**
 * Bounce the marker once and bring it to the foreground
 */
SearchMapMarkerMulti.prototype.bounce = function() {
    var listings = this.listings;
    var listingElement = '';

    listings.forEach(function(listing){
        listingElement = $(".listing[data-unitid=" + listing.unitID + "] .mod-listing");
        // When user leaves hover state on listing, color goes from orange to white
        $(listingElement).mouseleave(function() { 
            this.setIcon(this.getMarkerImage(false, this.label));
        }.bind(this));
        $(listingElement).hover(function() {
            this.setZIndex(google.maps.Marker.MAX_ZINDEX + 1000);
        }.bind(this));
    }.bind(this));

    this.setIcon(this.getMarkerImage(true, this.label));
    this.setAnimation(google.maps.Animation.BOUNCE);


    window.setTimeout(function () {
        this.setAnimation(null);
    }.bind(this), 700);

    this.setZIndex(google.maps.Marker.MAX_ZINDEX + 1000);
};

/**
 * When an event marker is clicked, open an InfoWindow displaying listing information
 */
SearchMapMarkerMulti.prototype.evtMarkerClick = function(evt) {
    this.infoWindow.renderListings(this.listings, this.listings.length);
    this.infoWindow.open(this.map, this);
};

/**
 * Hover on Marker highlights corresponding listing
 */
SearchMapMarkerMulti.prototype.evtMarkerHover = function(evt) {
    // Update marker icon with image stack
    this.setIcon(this.getMarkerImage(true,this.label));
};

/**
 * Resetting marker image and z-index
 */
SearchMapMarkerMulti.prototype.evtMarkerHoverLeave = function(evt) {
    var image = this.getMarkerImage(false, this.label);
    // Updating marker icon with image stack
    this.setIcon(image);
};

/**
 * Generates a Vacasa-branded marker image for displaying on the screen
 * @param  {boolean} hovered If the image should represent the hover state for the marker
 * @param  {string}  label   The number of multi units
 * @return {Object}          An object describing the image attributes
 */
SearchMapMarkerMulti.prototype.getMarkerImage = function(hovered, label) {

    var isIE = false;
    var size = new google.maps.Size(32, 32);
    var scaledSize = new google.maps.Size(32, 32);
    var anchor = new google.maps.Point(15, 33);
    var fillColor = 'white';
    var strokeColorInner = 'rgb(39, 26, 22)';
    var strokeColorOuter = 'rgb(100, 100, 100)';
    var url;
    var isAllBooked = allBooked(this.listings);

    // Test for inactive pins
    function allBooked(x) {
        for(var i = 0; i < x.length; i++) {
            if (x[i].active === false) {
                if(x[i].active !== x[0].active) {
                   // console.log("False - multipin is partially booked");
                    return false;
                }
                //console.log("True - multipin is all booked");
                return true;
            }
        }
    }

    // check if browser is IE
    if(jQuery.browser.msie || jQuery.browser.msedge) {
        isIE = true;
    }

    if (isIE) {
        // If inactive
        if (isAllBooked) {
            if (hovered) {
                url = '/images/ieMultiMarkerInactiveHovered_gray.png';
            }
            else {
                url = '/images/ieMultiMarkerInactive_gray.png';
            }
        }
        // If active
        else {
            if (hovered) {
                url = '/images/ieMultiMarkerHovered_gray.png';
            }
            else {
                url = '/images/ieMultiMarker_gray.png';
            }
        }
    }
    else {
        if (hovered)
            fillColor = 'rgb(240, 180, 33)';

        if (isAllBooked) {
            strokeColorInner = 'rgb(143,143,143)';
            strokeColorOuter = 'rgb(191,191,191)';
        }

        url = 'data:image/svg+xml;utf-8, \
        <svg height="32px" width="32px" id="multi-test" data-name="multi" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"> \
            <circle cx="16" cy="16" r="16" fill="' + strokeColorInner + '"/> \
            <circle cx="16" cy="16" r="15" fill="' + strokeColorOuter + '" /> \
            <circle cx="16" cy="16" r="10" fill="' + fillColor + '" stroke="white" stroke-width="1.2" /> \
            <text dx="50%" dy="21" fill="black" text-anchor="middle" font-size="14px" font-weight="normal" font-family="ssp, Source Sans Pro, Helvetica, Arial, sans-serif">' + label + '</text> \
        </svg>';
    }

    // All the things that make up the marker image
    var image = {
        url: url,
        size: size,
        scaledSize: scaledSize,
        anchor: anchor
    };
    return image;
};

window.SearchMapMarkerMulti = SearchMapMarkerMulti;



//////////////////
// WEBPACK FOOTER
// ./src/js/searchResults/SearchMapMarkerMulti.js
// module id = 11
// module chunks = 0